import { render, staticRenderFns } from "./NavigationItems.vue?vue&type=template&id=0c43cb7b&scoped=true&"
import script from "./NavigationItems.vue?vue&type=script&lang=js&"
export * from "./NavigationItems.vue?vue&type=script&lang=js&"
import style0 from "./NavigationItems.vue?vue&type=style&index=0&id=0c43cb7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43cb7b",
  null
  
)

export default component.exports